import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { REVIEWS } from '../data/content';

const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % REVIEWS.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + REVIEWS.length) % REVIEWS.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-primary-orange font-bold tracking-wider uppercase mb-3">Iskustva</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-neutral-darkNavy">Šta kažu naši klijenti?</h3>
          <p className="text-gray-500 mt-4">Recenzije sa Google Maps-a</p>
        </div>

        <div className="max-w-4xl mx-auto relative">
          {/* Navigation Buttons */}
          <button 
            onClick={prevReview}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-10 bg-white p-3 rounded-full shadow-lg text-primary-blue hover:bg-primary-blue hover:text-white transition-colors"
            aria-label="Previous review"
          >
            <ChevronLeft size={24} />
          </button>
          
          <button 
            onClick={nextReview}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 z-10 bg-white p-3 rounded-full shadow-lg text-primary-blue hover:bg-primary-blue hover:text-white transition-colors"
            aria-label="Next review"
          >
            <ChevronRight size={24} />
          </button>

          <div className="overflow-hidden px-4">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.3 }}
                className="bg-gray-50 p-8 md:p-12 rounded-3xl relative text-center"
              >
                <Quote className="absolute top-8 left-8 text-primary-blue/10 w-16 h-16" />
                
                <div className="flex flex-col items-center mb-8 relative z-10">
                  <div className="w-20 h-20 bg-primary-blue text-white rounded-full flex items-center justify-center font-bold text-3xl mb-4 shadow-md">
                    {REVIEWS[currentIndex].name.charAt(0)}
                  </div>
                  <h4 className="text-2xl font-bold text-neutral-darkNavy mb-2">{REVIEWS[currentIndex].name}</h4>
                  <div className="flex text-yellow-400 gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={20} fill="currentColor" />
                    ))}
                  </div>
                </div>
                
                <p className="text-gray-600 text-lg md:text-xl italic leading-relaxed relative z-10">
                  "{REVIEWS[currentIndex].text}"
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {REVIEWS.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentIndex ? 'bg-primary-orange' : 'bg-gray-300'
                }`}
                aria-label={`Go to review ${index + 1}`}
              />
            ))}
          </div>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="https://www.google.com/maps/place/Tepih+Servis+Tip-Top+Novi+Sad/@45.2368357,19.8224633,17z/data=!4m8!3m7!1s0x475b103c66055555:0x5555555555555555!8m2!3d45.2368357!4d19.8224633!9m1!1b1!16s%2Fg%2F11h0_00000?entry=ttu" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-primary-blue font-semibold hover:underline"
          >
            Pogledajte sve recenzije na Google-u
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
